// Single canonical home of the card experience; founders are addressed by ?person=
export const CARD_URL = "https://ascendfinances.co/card/";
export const personUrl = (slug) => `${CARD_URL}?person=${slug}`;
// All ASCEND card-home navigation stays inside the digital-card experience.
export const PROFILE_URL = CARD_URL;
export const COMPANY = "ASCEND Finance Group";
export const COMPANY_TAGLINE =
  "Finance, compliance and advisory for growing businesses — simplified.";
// Firm-level WhatsApp shown on the landing state
export const COMPANY_WHATSAPP = "919724651072";
// "wordmark" = serif firm name only | "logo" = uploaded logo artwork
export const FRONT_STYLE = "logo";

export const FOUNDERS = {
  anil: {
    slug: "anil",
    name: "CA Anil Luhar",
    prefix: "CA",
    firstName: "Anil",
    lastName: "Luhar",
    designation: "Co-Founder",
    phone: "+919724651072",
    phoneDisplay: "+91 97246 51072",
    email: "connect@ascendfinances.co",
    whatsapp: "919724651072",
    whatsappDisplay: "+91 97246 51072",
    location: "Ahmedabad, India",
  },
  suraj: {
    slug: "suraj",
    name: "CA Suraj Trivedi",
    prefix: "CA",
    firstName: "Suraj",
    lastName: "Trivedi",
    designation: "Co-Founder",
    phone: "+971563545090",
    phoneDisplay: "+971 56 354 5090",
    email: "connect@ascendfinances.co",
    whatsapp: "919724820035",
    whatsappDisplay: "+91 97248 20035",
    location: "Dubai, UAE",
  },
  dhaval: {
    slug: "dhaval",
    name: "Dhaval Prajapati",
    prefix: "",
    firstName: "Dhaval",
    lastName: "Prajapati",
    designation: "Co-Founder",
    phone: "+918141145434",
    phoneDisplay: "+91 81411 45434",
    email: "connect@ascendfinances.co",
    whatsapp: "918141145434",
    whatsappDisplay: "+91 81411 45434",
    location: "Ahmedabad, India",
  },
};
